import React from "react"
import Typography from "@material-ui/core/Typography"

/**
 * @param {{stringArray:string[]}} param1
 */
export default function StringArrayToParagraph({
  stringArray,
  paragraphClassname,
}) {
  if (!stringArray) return null
  return (
    <>
      {stringArray.map(paragraph => (
        <Typography key={paragraph} className={paragraphClassname}>
          {paragraph}
        </Typography>
      ))}
    </>
  )
}
